import NewsletterSubscriptionForm from '../NewsletterSubscriptionForm/NewsletterSubscriptionForm.vue';

export default {
  components: { NewsletterSubscriptionForm },
};
